export default "__VITE_ASSET__Dy7OvBRS__"